import axios from 'axios';
import apiConfig from '../api.config';

export default function getDoorOpeningList() {
  const {
    host,
    URIs: { doorOpeningList },
  } = apiConfig;

  const uri = `${host}${doorOpeningList}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
